import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navigation from "./components/navigation";
import PrivacyPolicy from "./pages/privacypolicy";
import TermsAndConditions from "./pages/termsandconditions";
import About from "./pages/about";
import Support from "./pages/support";

function App() {
  return (
    <Router>
      <Navigation />
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/support" element={<Support />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
}

export default App;
